import Home from './home'
import Customers from './customers'
import CustomerDetails from './customerDetails'
import Users from './userRole/users'
import Subsidiaries from './subsidiary/subsidiaries'
import SubsidiaryDetails from './subsidiary/subsidiaryDetails'
import Companies from './company/companies'
import CompanyDetails from './company/companyDetails'
import Settings from './settings'

export default [
    Home,
    Customers,
    CustomerDetails,
    Users,
    Subsidiaries,
    SubsidiaryDetails,
    Companies,
    CompanyDetails,
    Settings
]